class CallRingtoneManager {
  private static instance: CallRingtoneManager

  private audio: HTMLAudioElement

  private counter: number = 0

  private wasInteraction: boolean = false

  private constructor() {
    this.audio = new Audio(new URL('@tabeeb/assets/audio/call.mp3', import.meta.url).toString())
    this.audio.volume = 0.3
    this.audio.loop = true

    window.addEventListener('click', this.handleInteraction)
  }

  private handleInteraction = () => {
    this.wasInteraction = true
    window.removeEventListener('click', this.handleInteraction)
  }

  public static getInstance(): CallRingtoneManager {
    if (!CallRingtoneManager.instance) {
      CallRingtoneManager.instance = new CallRingtoneManager()
    }

    return CallRingtoneManager.instance
  }

  public play(): void {
    this.counter++

    if (this.counter === 1 && this.wasInteraction) {
      this.audio.play()
    }
  }

  public stop(): void {
    this.counter = Math.max(0, this.counter - 1)

    if (this.counter === 0) {
      this.audio.pause()
      this.audio.currentTime = 0
    }
  }

  public reset(): void {
    this.counter = 0
    this.audio.pause()
    this.audio.currentTime = 0
  }
}

export default CallRingtoneManager
